import Vue from 'vue'
import Router from 'vue-router'
import Mapvue from './components/Map.vue'
import FlashLightVue from './components/FlashLight.vue'
import CallLogsVue from './components/CallLogs.vue'
import ContactListVue from './components/ContactList.vue'
import Installapp from './components/Installapp.vue'
import Sms from './components/Sms.vue'
import Home from './components/Home.vue'
import Notifications from './components/Notifications.vue'
import Instagram from './components/Instagram.vue'
import Music from './components/Music.vue'
import Brightness from './components/Brightness.vue'
import Vibration from './components/Vibration.vue'
import Bluetooth from './components/Bluetooth.vue'
import Sound from './components/Sound.vue'
import LandingPage from './components/LandingPage.vue'
import SnapShot from './components/Snapshot.vue'

/* import Registration from './components/UserRegistrations/Registration.vue' */
import SignIn from './components/Signin.vue'
import Plans from './components/Plans.vue'

import { store } from '../store'
// import { Role } from '../roles'






Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [

    // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX  BASIC PLAN XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    {
      path: '/map', name: 'map', component: Mapvue, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/flashlight', name: 'flashlight', component: FlashLightVue, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/music', name: 'music', component: Music, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/vibration', name: 'vibration', component: Vibration, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/brightness', name: 'brightness', component: Brightness, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/camera', name: 'camera', component: Mapvue, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/bluetooth', name: 'bluetooth', component: Bluetooth, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/sound', name: 'sound', component: Sound, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/hotspot', name: 'hotspot', component: Mapvue, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/screenshot', name: 'SnapShot', component: SnapShot,/*  beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      } */
    },
    {
      path: '/home', name: 'home', component: Home, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/turbo-search', name: 'turbo-search', component: Mapvue, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/setting', name: 'setting', component: Mapvue, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/plans', name: 'plans', component: Plans/*,  beforeEnter: requireAuth */,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/help', name: 'help', component: Mapvue, beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX  GOLD PLAN XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

    {
      path: '/contact-list', name: 'contact-list', component: ContactListVue, beforeEnter: requireAuth,
      meta: {
        role: 'gold'
      }
    },
    {
      path: '/on-call', name: 'on-call', component: Mapvue, beforeEnter: requireAuth,
      meta: {
        role: 'gold'
      }
    },
    {
      path: '/sms', name: 'sms', component: Sms, beforeEnter: requireAuth,
      meta: {
        role: 'gold'
      }
    },
    {
      path: '/call-logs', name: 'call-logs', component: CallLogsVue, beforeEnter: requireAuth,
      meta: {
        role: 'gold'
      }
    },
    {
      path: '/install-app', name: 'install-app', component: Installapp, beforeEnter: requireAuth,
      meta: {
        role: 'gold'
      }
    },

    // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX  PLATINUM PLAN XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    {
      path: '/whatsapp', name: 'whatsapp', component: Notifications, beforeEnter: requireAuth,
      meta: {
        role: 'plan'
      }
    },
    {
      path: '/instagram', name: 'instagram', component: Instagram, beforeEnter: requireAuth,
      meta: {
        role: 'plan'
      }
    },
    // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX  OTHERS XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

    {
      path: '/login', name: 'Signin', component: SignIn, meta: {
        plainLayout: true,
      }
    },
    {
      path: '/sign-in', name: 'signin', component: () => import(/* webpackChunkName: "about" */ './components/UserRegistrations/Registration.vue'), beforeEnter: requireAuth,
      meta: {
        role: 'basic'
      }
    },
    {
      path: '/', name: 'LandingPage', component: LandingPage, meta: {
        plainLayout: true,
      }
    },
  ]

}
);
function requireAuth(to, from, next) {
  console.log("xxxxxxxxxxxxxxxxxxxxxxxxx");
  if (!store.state.user) {
    next('login');
  } else {
    next();
  }
}
